import { useMemo } from 'react';
import { IMetricsDataModel } from '../../../data-models/metrics.data-model';
import { useCompanyMapLookup } from '../../../services/hooks/useSaveCompanyData';
import { InvestmentAmount } from './useInvestmentAmountByState';

export function useInvestmentAmount(filteredData: IMetricsDataModel[]): InvestmentAmount {
  const getCompany = useCompanyMapLookup();

  return useMemo(() => {
    let total = 0;

    const groupedData = filteredData?.reduce(
      (a, c) => {
        const company = getCompany(c.companyId);
        const group = company?.country ?? 'Other';
        if (a[group]) {
          a[group] += c.amountInvested;
        } else {
          a[group] = c.amountInvested;
        }
        total += c.amountInvested;
        return a;
      },
      {} as Record<string, number>
    );

    const groupedArray = Object.entries(groupedData as Record<string, number>).map(([key, value]) => ({
      name: key,
      value: Number(value.toFixed(2)),
      id: key,
    }));

    groupedArray.sort((a, b) => (a.value > b.value ? -1 : b.value > a.value ? 1 : 0));

    return { data: groupedArray.slice(0, 10), total };
  }, [filteredData, getCompany]);
}
